export default "__VITE_ASSET__ByTKhYyg__"